export const AlternativeIconBig = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M42.5 42.5V48.75C42.5 50.4076 41.8415 51.9973 40.6694 53.1694C39.4973 54.3415 37.9076 55 36.25 55H11.25C9.5924 55 8.00268 54.3415 6.83058 53.1694C5.65848 51.9973 5 50.4076 5 48.75V23.75C5 22.0924 5.65848 20.5027 6.83058 19.3306C8.00268 18.1585 9.5924 17.5 11.25 17.5H17.5V11.25C17.5 9.5924 18.1585 8.00268 19.3306 6.83058C20.5027 5.65848 22.0924 5 23.75 5H48.75C50.4076 5 51.9973 5.65848 53.1694 6.83058C54.3415 8.00268 55 9.5924 55 11.25V36.25C55 37.9076 54.3415 39.4973 53.1694 40.6694C51.9973 41.8415 50.4076 42.5 48.75 42.5H42.5Z"
        stroke="#222530"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M23.75 17.5H17.5V23.75" stroke="#222530" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.5 36.25V42.5H23.75" stroke="#222530" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M36.25 17.5H42.5V23.75" stroke="#222530" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M42.5 36.25V42.5H36.25" stroke="#222530" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
